import React from 'react';
import Paragraph from '../../../paragraph';
import { INDENT_PX } from '../../constants';
const TreeSelectGroupLabel = ({ label, depth }) => (
  <div className="ws-ui-tree-select__group-label">
    <div style={{ paddingLeft: depth * INDENT_PX }}>
      <Paragraph appearance="medium-emphasis" size="small">
        {label}
      </Paragraph>
    </div>
  </div>
);

export default TreeSelectGroupLabel;
